module.exports = __webpack_public_path__ + "static/media/logo.21f06cc5.png";